let kreis, mouse;

let mouseX, mouseY; 
let kreisX, kreisY;

let projectList;

let delay; 

let bgColor = {
	h: 0,
	s: 0,
	l: 0
};

setup();
animate();


function setup() {
	mouseX = 0;
	mouseY = 0;
	kreisX = 0;
	kreisY = 0;
	delay = 0.05;

	mouse = document.getElementById('circle');
	kreis = document.getElementById('kreis');
	square = document.getElementById('square');	
	projectList = document.querySelector('.background');

	// Bind mousemouse event handler to window
	window.addEventListener('mousemove', onMouseMove);
}

function update() {
	let distX = mouseX - kreisX;	
	let distY = mouseY - kreisY;

	kreisX = kreisX + distX*delay ;
	kreisY = kreisY + distY*delay ;

	bgColor.h = Math.round(mapRange(kreisX, 0, window.innerWidth, 0, 360));
	bgColor.s = Math.round(mapRange(kreisX, 0, window.innerWidth, 0, 100));
	// bgColor.s = 100;
	bgColor.l = 60;

	// console.log("s", bgColor.s, "l", bgColor.l);
}


function draw() {
	mouse.style.transform = `translate(${mouseX}px, ${mouseY}px)`;  
	kreis.style.transform = `translate(${kreisX}px, ${kreisY}px)`; 
	
	// projectList.style.backgroundColor = "hsl(" + bgColor.s + "," + bgColor.l + ",40)"; 
	const colorStyle = 	`hsl(${bgColor.h}, ${bgColor.s}%, ${bgColor.l}%)`;
	projectList.style.backgroundColor = colorStyle;
	console.log(colorStyle);
}

function animate() {
	update();
	draw();

	window.requestAnimationFrame(animate);
}


function onMouseMove (e) {
	mouseX = e.clientX;
	mouseY = e.clientY;
}

function mapRange (value, inMin, inMax, outMin, outMax) {
  return (value - inMin) * (outMax - outMin) / (inMax - inMin) + outMin;

}


document.addEventListener('DOMContentLoaded', function () {
    const dropdownToggle = document.querySelector('.dropdown-toggle');
    const dropdownMenu = document.querySelector('.dropdown-menu');

    // Klick-Event für den Toggle-Button
    dropdownToggle.addEventListener('click', function () {
        dropdownMenu.classList.toggle('show'); // Zeigt/versteckt das Menü
    });

    // Optional: Klick außerhalb des Dropdown-Menüs schließt es
    document.addEventListener('click', function (e) {
        if (!dropdownToggle.contains(e.target) && !dropdownMenu.contains(e.target)) {
            dropdownMenu.classList.remove('show');
        }
    });
});
